import { render } from "./Configuracion2FA.vue?vue&type=template&id=4cf8a059"
import script from "./Configuracion2FA.vue?vue&type=script&lang=js"
export * from "./Configuracion2FA.vue?vue&type=script&lang=js"

import "./Configuracion2FA.vue?vue&type=style&index=0&id=4cf8a059&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__